/**
 * Common popup mixins
 *
 */
import EventBus from '@/vue/events/event-bus'

export default {
    
    methods : {
      popupBreath(){
        var VUE = this
        if(this.democreditLogin == true){
          $('.fadeinDemo').fadeIn();   
        }
      },
      closePopup(){
        EventBus.$emit('setDemoFlag', false)
        $('.fadeinDemo').fadeOut();
      },
      login(){
        if(this.token_demo == '' || (typeof this.token_demo=='undefined') ) {
            this.error.tokenReq = true
            this.error.tokenmessage = this.lang.emptytoken
        }else{
          var re = /^[a-z\d\-_\s]+$/i;
          var re1= re.test(this.token_demo);
          //console.log(re1);
          if(re1){
            var url =_baseUrl+'/login';
            this.$ajax({
                method: 'post',
                url: url,
                data:  {
                            token : this.token_demo,
                            action: 'logincreditdemo',
                        }
            }).done(response => {
                console.log("done");
            }).catch(error => {
                this.error.tokenReq = true
                this.error.tokenmessage = error.responseJSON.message
            })
          }else{
              this.error.tokenReq = true
               this.error.tokenmessage = this.lang.invalidtoken;
          }

        }

      
      }
  
    }
  }
  


// WEBPACK FOOTER //
// ./resources/wob/vue/mixins/popup.js